import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { NotebookPen, History } from "lucide-react";

export default function TopicAdminPanel() {
  const [current, setCurrent] = useState(null);
  const [past, setPast] = useState([]);
  const [question, setQuestion] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const [c, list] = await Promise.all([
        api.get("/topic/current"),
        api.get("/admin/topics"),
      ]);
      setCurrent(c.data.topic);
      setPast(list.data);
    } catch (e) { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!question.trim()) return;
    setBusy(true);
    try {
      await api.post("/admin/topics", { question });
      toast.success("new topic is live · listeners will see it on /episodes");
      setQuestion("");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "could not save");
    } finally { setBusy(false); }
  };

  return (
    <div className="mb-10" data-testid="topic-admin-panel">
      <div className="flex items-center gap-3 mb-4 flex-wrap">
        <NotebookPen className="text-hotpink" size={22} />
        <h2 className="brush-title text-3xl md:text-4xl text-white">TOPIC OF THE <span className="text-hotpink">WEEK.</span></h2>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-coal border border-hotpink/40 p-5">
          <div className="text-xs uppercase tracking-widest text-white/60 font-outfit mb-2">Currently live</div>
          {current ? (
            <p className="brush-title text-2xl text-white leading-tight">"{current.question}"</p>
          ) : (
            <p className="text-white/50 font-outfit text-sm italic">no topic set yet</p>
          )}
          <form onSubmit={create} className="mt-5 space-y-2" data-testid="topic-admin-form">
            <input value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="next question · 'What's the wildest first-date red flag?'" maxLength={300} required data-testid="topic-question-input" className="w-full bg-ink border border-white/15 px-3 py-2 text-white font-outfit text-sm focus:border-hotpink focus:outline-none" />
            <button type="submit" disabled={busy || !question.trim()} data-testid="topic-publish" className="w-full bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-xs px-4 py-2 disabled:opacity-60">
              {busy ? "..." : "publish · replaces current"}
            </button>
            <p className="text-[10px] text-white/40 uppercase tracking-widest font-outfit">publishing a new one archives the current topic. past entries stay readable.</p>
          </form>
        </div>
        <div className="bg-coal border border-white/10 p-5">
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/60 font-outfit mb-3">
            <History size={14} className="text-hotpink"/> Topic history
          </div>
          {past.length === 0 ? (
            <p className="text-white/40 font-outfit text-sm italic">no past topics yet</p>
          ) : (
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {past.map(t => (
                <div key={t.id} className="border-b border-white/5 pb-2 text-sm" data-testid={"topic-past-" + t.id.slice(0,8)}>
                  <div className="flex items-baseline gap-2 flex-wrap">
                    <span className={"font-outfit font-bold " + (t.active ? "text-hotpink" : "text-white/80")}>{t.active ? "● live" : "○ archived"}</span>
                    <span className="text-white/40 text-[10px] uppercase tracking-widest ml-auto">{new Date(t.created_at).toLocaleDateString()}</span>
                  </div>
                  <p className="font-outfit text-white/80 mt-1">{t.question}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
